var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8209 11.5322L18.3531 9.9994L13.9966 5.64126M3 21L6.68745 20.5905C6.98675 20.5717 7.28352 20.5238 7.57355 20.4474C7.76005 20.3871 7.93755 20.3019 8.10127 20.1942C8.33943 20.0147 8.55966 19.8125 8.75886 19.5906L20.0974 8.26272C20.6753 7.68458 21 6.90045 21 6.08283C21 5.26521 20.6753 4.48108 20.0974 3.90294C19.5195 3.3248 18.7356 3 17.9183 3C17.101 3 16.3171 3.3248 15.7392 3.90294L4.40889 15.2308C4.18699 15.4301 3.98493 15.6504 3.80555 15.8886C3.6978 16.0524 3.61264 16.23 3.55238 16.4166C3.47595 16.7067 3.42805 17.0036 3.40935 17.303L3 21Z",
    stroke: "#66338F",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit4);
export default __webpack_public_path__ + "static/media/edit-4.d136d41eb528eedc280128f48dcbde51.svg";
export { ForwardRef as ReactComponent };